// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import AntCloudOutlinedSvg from "@fishx/icons-svg/es/asn/AntCloudOutlined";
import FishxIcon from '../components/FishxIcon';

var AntCloudOutlined = function AntCloudOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: AntCloudOutlinedSvg
  }));
};

AntCloudOutlined.displayName = 'AntCloudOutlined';
export default React.forwardRef(AntCloudOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/AntCloudOutlined.js
// module id = 1985
// module chunks = 0